type OmitNulls<T> = {
  [K in keyof T as null extends T[K] ? never : K]: T[K];
};

export function omitNulls<T extends Record<string, unknown>>(object: T) {
  const entries = Object.entries(object).filter(([, value]) => value !== null);
  return Object.fromEntries(entries) as OmitNulls<T>;
}
